// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DkTH","top":"styles_top__3EBkz"};